<div class="c-modal c-modal--d -large">
  <div class="c-modal__inner">
    <div class="c-modal__head">
      <div *ngIf="!confirm" class="c-modal__close" (click)="close()">
        <p500-ui-icon name="controls-close"></p500-ui-icon>
      </div>
      <div *ngIf="confirm" class="c-modal__title text-color--gray">
        <ng-container i18n="@@common.unconfirmed_documents">Unconfirmed Documents</ng-container>:
      </div>
    </div>
    <div class="c-modal__body">
      <ng-container *ngIf="!isLoading; else loadingTmpl">
        <div *ngFor="let item of docs; index as i;" class="mb-20">
          <div class="c-modal__title">
            <span>{{ item.document.name }}</span>
            <span class="text-color--gray" *ngIf="docs.length > 1">&nbsp;#{{ i + 1 }}</span>
          </div>
          <div [innerHTML]="item.document.text"></div>
        </div>
      </ng-container>
    </div>
    <div *ngIf="confirm" class="c-modal__footer">
      <button type="button" p500-ui-button (click)="submit()">
        <span i18n="@@common.confirm">Confirm</span>
        <span *ngIf="docs.length > 1" i18n="@@common.all">&nbsp;All</span>
      </button>
    </div>
  </div>
</div>
<ng-template #loadingTmpl>
  <p500-ui-cube-preloader></p500-ui-cube-preloader>
</ng-template>
